// Every component that loads the Google Maps script (LoadScript / useJsApiLoader)
// must use the exact same apiKey + libraries, otherwise @react-google-maps/api's
// underlying Loader singleton throws "Loader must not be called again with
// different options" and crashes the whole app with a blank screen.
export const GOOGLE_MAPS_API_KEY = "AIzaSyAA8XXFgdVi3SgSZdVJ7kFfaZGvUa_s9hI";
export const GOOGLE_MAPS_LIBRARIES = ["places"];
